import { styled } from "@woba/ds-web";

export const TabBarNavigationContainer = styled("div", {
  bottom: 0,
});
